import React from 'react';

// components
import CommonSidebar from "../Common/CommonSidebar";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";

//icons
import GroupIcon from "@mui/icons-material/Group";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import CelebrationIcon from '@mui/icons-material/Celebration';


class HRSidebar extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            applicantGroup: null,
            employeeGroup: null,
        };
    }

    async componentDidMount() {
        await this.retrieveApplicantPermission();
        await this.retrieveEmployeePermission();
    }

    async retrieveApplicantPermission(){
        let p = await retrievePermission(
            'ApplicantViewSet',
            'create',
            this.context.subscriberObject
        );
        p *= await retrievePermission(
            'ApplicantViewSet',
            'list',
            this.context.subscriberObject
        );
        if (p){
            this.setState(
                {
                    applicantGroup: {
                        title: 'Соискатели',
                        items: [
                            {
                                title: 'Список',
                                link: '/hr/applicant/',
                                icon: GroupIcon,
                            },
                        ],
                    },
                }
            );
        }
    }

    async retrieveEmployeePermission(){
        let items = [];
        let p = await retrievePermission(
            'VacationViewSet',
            'create',
            this.context.subscriberObject
        );
        p *= await retrievePermission(
            'VacationViewSet',
            'list',
            this.context.subscriberObject
        );
        if (p){
            items.push(
                {
                    title: 'Отпуски',
                    link: '/hr/vacation/',
                    icon: HolidayVillageIcon,
                },
            )
        }
        p = await retrievePermission(
            'HolidayViewSet',
            'create',
            this.context.subscriberObject
        );
        p *= await retrievePermission(
            'HolidayViewSet',
            'list',
            this.context.subscriberObject
        );
        if (p){
            items.push(
                {
                    title: 'Выходные',
                    link: '/hr/holiday/',
                    icon: CelebrationIcon,
                },
            )
        }
        if (items.length){
            this.setState(
                {
                    employeeGroup: {
                        title: 'Сотрудники',
                        items: items
                    },
                }
            );
        }
    }

    render() {
        let groups = [];
        if (this.state.applicantGroup) {
            groups.push(this.state.applicantGroup)
        }
        if (this.state.employeeGroup) {
            groups.push(this.state.employeeGroup)
        }
        return(
            <CommonSidebar
                groups={groups}
            />
        )
    }
}

export default HRSidebar
